import React, { Component } from 'react';
import ReactDOMServer from 'react-dom/server';
import DropzoneComponent from 'react-dropzone-component';
import { injectIntl } from 'react-intl';
import { parseClasses, i18nIntl } from '../../lib/ep.js';

import FieldErrorMessage from './FieldErrorMessage';
import FieldLabel from './FieldLabel';

var eventHandlers_default = {}

var componentConfig_default = {
	iconFiletypes: ['.jpg', '.png', '.gif'],
	showFiletypeIcon: true,
	postUrl: '/uploadHandler',
};

var djsConfig_default = {
	autoProcessQueue: false,
	thumbnailWidth:null,
	thumbnailHeight:null,
	createImageThumbnails:false,
	previewTemplate: ReactDOMServer.renderToStaticMarkup(
		<div>
			<div className="dz-details">
				<img data-dz-thumbnail="true" />
			</div>
			<div className="dz-progress"><span className="dz-upload" data-dz-uploadprogress="true"></span></div>
		</div>
	)
}

var mimetypes = {
	all:[],
	image:['image/jpeg','image/gif','image/png','image/bmp','image/tiff','image/x-icon'],
	video:['video/x-ms-asf', 'video/x-ms-wmv', 'video/x-ms-wmx', 'video/x-ms-wm', 'video/avi', 'video/divx', 'video/x-flv', 'video/quicktime', 'video/mpeg', 'video/mp4', 'video/ogg', 'video/webm', 'video/x-matroska','video/3gpp'],
	audio:['audio/mpeg', 'audio/mpeg', 'audio/x-mpequrl', 'audio/mp3', 'audio/x-realaudio', 'audio/wav', 'audio/ogg', 'audio/midi', 'audio/x-ms-wma', 'audio/x-ms-wax', 'audio/x-matroska'],
	text:['text/plain', 'text/csv', 'text/richtext', 'text/html', 'application/rtf', 'application/msword', 'application/vnd.ms-powerpoint', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.oasis.opendocument.text', 'application/vnd.oasis.opendocument.presentation', 'application/vnd.oasis.opendocument.spreadsheet', 'application/pdf'],
	application:['application/pdf','application/x-tar','application/zip','application/x-gzip','application/rar']
}
for(var i in mimetypes) {
	for(var j in mimetypes[i]) {
		mimetypes['all'].push(mimetypes[i][j]);
	}
}

function DropzoneUploader(props) {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const componentConfig = props?.componentConfig ?? componentConfig_default;
	const djsConfig = props?.djsConfig ?? djsConfig_default;
	const eventHandlers = props?.eventHandlers ?? eventHandlers_default;
	const disabled = props?.disabled ?? false;

	const has_error = (props.errors && props.errors[props.name]) ? props.errors[props.name] : false;

	let thumb_prop = 1.618;
	const thumb_w = 300;

	var size_specs = false;
	if(props._size) {
		size_specs = props._size.width + '×' + props._size.height + 'px';
		thumb_prop = props._size.width / props._size.height;
	}
	const thumb_h = thumb_w / thumb_prop;

	let _style = (props.style) ? props.style : {};
	_style.width = thumb_w + 'px';
	_style.height = thumb_h + 'px';

	let dd_classes = 'image_uploader file_uploader with_dragger gui_pos_rel';
	const dd_size = (props.dd_size != undefined) ? props.dd_size : 'dynamic';
	if(dd_size == 'full_w') dd_classes += ' small_drag_message';

	let size_class = false;
	let classname = props?.classname ?? 'input file';
	if(disabled) classname += ' disabledField';
	if(props.small_input != undefined && props.small_input) {
		classname += ' is_small_input';
		preview = false;
	}
	if(size_class) classname += ' ' + size_class;
	classname = parseClasses(classname, props._class, 'imageuploader');

	const autotranslate = props?.autotranslate ?? true;

	let display_custom_dragging_instructions = false;
	if(props.display_custom_dragging_instructions != undefined) {
		display_custom_dragging_instructions = (autotranslate) ? i18n(props.display_custom_dragging_instructions) : props.display_custom_dragging_instructions;
	}

	const _extra = (props._extra != undefined) ? props._extra : ((size_specs) ? size_specs : null);
	const display_extra_info = props?.display_extra_info ?? true;

	var accepted_formats = false;
	if(props._accepted_formats != undefined) {
		accepted_formats = [];
		for(let format in props._accepted_formats) {
			accepted_formats.push(i18n(props._accepted_formats[format]));
		}
	}

	const accepted_formats_position = (props.accepted_formats_position != undefined) ? props.accepted_formats_position : ((!window.is_rtl) ? 'mod_align_right' : 'mod_align_left');

	return (
		<div class={'react_field' + ((props._field_class != undefined) ? ' ' + props._field_class : '')}>
			<div class={classname}>
				<FieldLabel
					{...props.label_props}
					name={props.name}
					autotranslate={props.autotranslate}
				>{props.children}</FieldLabel>

				<figure class={dd_classes} style={_style}>
					<DropzoneComponent config={componentConfig} eventHandlers={eventHandlers} djsConfig={djsConfig}>
						<div style={{height:'100%'}}>
							<div class="dz-message">
								{(!display_custom_dragging_instructions) ? (
									<span class="drag_message">
										<span class="original_color_item">{i18n("Click to Select and Upload File")}</span>
										<span class="original_color_item gui_only_desktop">{i18n("or")}</span>
										<span class="original_color_item gui_only_desktop">{i18n("Drag and Drop File")}</span>
									</span>
								) : (
									<span class="drag_message">
										<span class="original_color_item" dangerouslySetInnerHTML={{ __html:display_custom_dragging_instructions }} />
									</span>
								)}
							</div>

							<img src={window.cdn_url + 'img/blank.png'} width="100%" height="100%" />
						</div>
					</DropzoneComponent>
				</figure>

				{(has_error) && (
					<FieldErrorMessage>{has_error}</FieldErrorMessage>
				)}

				{(props.recommendations != undefined && props.recommendations != '') && (
					<div class="gui_field_recommendations">{props.recommendations}</div>
				)}

				{(props.after_component != undefined) && (
					<span class="label_additional_msg gui_after_message whole_contents">{props.after_component}</span>
				)}

				{(display_extra_info && accepted_formats) && (
					<div class={'gui_after_message ' + accepted_formats_position}>
						{i18n("Valid formats")}: {accepted_formats.join(", ")}
						{(props.max_filesize != undefined && props.max_filesize != "") && (
							<span> | {i18n("Maximum size per file")}: {props.max_filesize}</span>
						)}
					</div>
				)}
			</div>
		</div>
	);
}

export default injectIntl(DropzoneUploader);